import type { ComponentProps } from 'react';
import { Dialog as Primitive } from 'radix-ui';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
import '../../styles/form-dialog.css';

// Uma superfície de edição comum; o Radix preserva foco, Escape e diálogos aninhados.
export const FormDialog = Primitive.Root;
export const FormDialogTitle = Primitive.Title;
export const FormDialogDescription = Primitive.Description;

export function FormDialogContent({ children, className, size = 'default', ...props }: ComponentProps<typeof Primitive.Content> & { size?: 'default' | 'wide' }) {
  return (
    <Primitive.Portal>
      <Primitive.Overlay className="form-dialog-overlay" />
      <Primitive.Content className={cn('form-dialog', className)} data-form-dialog="true" data-size={size} {...props}>
        {children}
        <Primitive.Close className="form-dialog-close" aria-label="Fechar">
          <X size={20} aria-hidden="true" />
        </Primitive.Close>
      </Primitive.Content>
    </Primitive.Portal>
  );
}

export function FormDialogBody({ className, ...props }: ComponentProps<'div'>) {
  return <div data-slot="form-dialog-body" className={cn('form-dialog-body', className)} {...props} />;
}

export function FormDialogHeader({ className, ...props }: ComponentProps<'div'>) {
  return <div data-slot="form-dialog-header" className={cn('form-dialog-header', className)} {...props} />;
}

export function FormDialogFooter({ className, ...props }: ComponentProps<'div'>) {
  return <div data-slot="form-dialog-footer" className={cn('form-dialog-footer', className)} {...props} />;
}
